import { ManageRolesTableDataItem } from "PFApp/activities/manage_roles/manage_roles.types";
import { RolesFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { ColumnHelper } from "PFComponents/table/table.types";

import { createReadonlyWmColumn } from "./readonly_wm_cell";

export const createBookedWmColumn = (
  columnHelper: ColumnHelper<ManageRolesTableDataItem>,
  rolesFormKey: RolesFormKey,
  headerLabel: string
) =>
  createReadonlyWmColumn({
    columnHelper,
    rolesFormKey,
    headerLabel,
    fieldName: "booked_wm",
    qaId: "ManageRoles.RoleRow.BookedWm"
  });
